import moment from "moment";

export const getField = function (item, field) {
  return item.getDocumentValue(field);
};

export const deserializeField = function (item, field) {
  if (item && item.Document && item.Document.hasOwnProperty(field)) {
    var data = item.Document[field];

    if (data.length) {
      try {
          data = data.map(function (i) { return JSON.parse(i); });
      } catch (e) {
        console.error(e);
      }
    }

    return data;
  }
};

export const tooltip = function (event) {
  var toggletip = event.target;
  var message = toggletip.getAttribute("data-toggletip-content");

  // Get the live region element
  var liveRegion = toggletip.nextElementSibling;

  // Toggle the message
  liveRegion.innerHTML = "";
  window.setTimeout(function () {
    liveRegion.innerHTML =
      '<span class="toggletip-bubble">' + message + "</span>";
  }, 100);

  // Close on outside click
  document.addEventListener("click", function (e) {
    if (toggletip !== e.target) {
      liveRegion.innerHTML = "";
    }
  });

  // Remove toggletip on ESC
  toggletip.addEventListener("keydown", function (e) {
    if ((e.keyCode || e.which) === 27) liveRegion.innerHTML = "";
  });
};

export const isElementThisPercentInViewport = function (
  element,
  percentVisible
) {
  let rect = element.getBoundingClientRect();
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  return !(
    Math.floor(
      100 - ((rect.left >= 0 ? 0 : rect.left) / +-(rect.width / 1)) * 100
    ) < percentVisible ||
    Math.floor(100 - ((rect.right - windowWidth) / rect.width) * 100) <
      percentVisible
  );
};

export const padZerosToString = function (str) {
  let withAdditionalZeros = str;
  while (withAdditionalZeros.length < 10) {
    withAdditionalZeros = "0" + withAdditionalZeros;
  }
  return withAdditionalZeros;
};

export const formatDate = function (date) {
  let monthFormat;
  let dayFormat;
  const dateMonth = moment(date).month();
  const dateDay = moment(date).date();

  if (dateMonth === 4) {
    monthFormat = "MMM";
  } else {
    monthFormat = "MMM.";
  }

  if (dateDay >= 10) {
    dayFormat = "D,";
  } else if (dateDay < 10) {
    dayFormat = "D,";
  }

  return `${monthFormat} ${dayFormat} YYYY`;
};
